__turbopack_context__.v({
  "accordionSlideOverwrite": "campaignHeader-module-scss-module__1PPKUa__accordionSlideOverwrite",
  "accountEmail": "campaignHeader-module-scss-module__1PPKUa__accountEmail",
  "accountMenu": "campaignHeader-module-scss-module__1PPKUa__accountMenu",
  "accountMenuDivider": "campaignHeader-module-scss-module__1PPKUa__accountMenuDivider",
  "accountMenuHeader": "campaignHeader-module-scss-module__1PPKUa__accountMenuHeader",
  "accountMenuItem": "campaignHeader-module-scss-module__1PPKUa__accountMenuItem",
  "accountName": "campaignHeader-module-scss-module__1PPKUa__accountName",
  "actions": "campaignHeader-module-scss-module__1PPKUa__actions",
  "authButtons": "campaignHeader-module-scss-module__1PPKUa__authButtons",
  "avatarButton": "campaignHeader-module-scss-module__1PPKUa__avatarButton",
  "campaignHeader": "campaignHeader-module-scss-module__1PPKUa__campaignHeader",
  "closeButton": "campaignHeader-module-scss-module__1PPKUa__closeButton",
  "container": "campaignHeader-module-scss-module__1PPKUa__container",
  "fadeIn": "campaignHeader-module-scss-module__1PPKUa__fadeIn",
  "fadeOut": "campaignHeader-module-scss-module__1PPKUa__fadeOut",
  "hamburgerButton": "campaignHeader-module-scss-module__1PPKUa__hamburgerButton",
  "loginButton": "campaignHeader-module-scss-module__1PPKUa__loginButton",
  "logo": "campaignHeader-module-scss-module__1PPKUa__logo",
  "logoLink": "campaignHeader-module-scss-module__1PPKUa__logoLink",
  "logoWrapper": "campaignHeader-module-scss-module__1PPKUa__logoWrapper",
  "mobileAccountDetails": "campaignHeader-module-scss-module__1PPKUa__mobileAccountDetails",
  "mobileAccountEmail": "campaignHeader-module-scss-module__1PPKUa__mobileAccountEmail",
  "mobileAccountInfo": "campaignHeader-module-scss-module__1PPKUa__mobileAccountInfo",
  "mobileAccountName": "campaignHeader-module-scss-module__1PPKUa__mobileAccountName",
  "mobileAuthButton": "campaignHeader-module-scss-module__1PPKUa__mobileAuthButton",
  "mobileAuthButtons": "campaignHeader-module-scss-module__1PPKUa__mobileAuthButtons",
  "mobileMenu": "campaignHeader-module-scss-module__1PPKUa__mobileMenu",
  "mobileMenuHeader": "campaignHeader-module-scss-module__1PPKUa__mobileMenuHeader",
  "mobileNav": "campaignHeader-module-scss-module__1PPKUa__mobileNav",
  "mobileNavDivider": "campaignHeader-module-scss-module__1PPKUa__mobileNavDivider",
  "mobileNavIcon": "campaignHeader-module-scss-module__1PPKUa__mobileNavIcon",
  "mobileNavLink": "campaignHeader-module-scss-module__1PPKUa__mobileNavLink",
  "mobileNavLinkWithIcon": "campaignHeader-module-scss-module__1PPKUa__mobileNavLinkWithIcon",
  "mobileNavList": "campaignHeader-module-scss-module__1PPKUa__mobileNavList",
  "nav": "campaignHeader-module-scss-module__1PPKUa__nav",
  "navLink": "campaignHeader-module-scss-module__1PPKUa__navLink",
  "navList": "campaignHeader-module-scss-module__1PPKUa__navList",
  "orIndicator": "campaignHeader-module-scss-module__1PPKUa__orIndicator",
  "scaleIn": "campaignHeader-module-scss-module__1PPKUa__scaleIn",
  "scaleOut": "campaignHeader-module-scss-module__1PPKUa__scaleOut",
  "signUpButton": "campaignHeader-module-scss-module__1PPKUa__signUpButton",
  "zoomIn": "campaignHeader-module-scss-module__1PPKUa__zoomIn",
  "zoomOut": "campaignHeader-module-scss-module__1PPKUa__zoomOut",
});
